module.exports = __webpack_public_path__ + "img/br2.b30e84e6.png";